var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 2H0v2.003h24V2zm0 3.997H0V8h24V5.997zm0 4.005H0v2.003h24v-2.003zM24 14H0v2.003h24V14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E52B2",
    d: "M12-.003H0v8.618h12V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M4.68 3.53l-.195.593h-.622l.502.367-.195.593.51-.368.503.368-.188-.593.503-.367h-.623L4.68 3.53zm.195 2.738l-.195-.593-.195.593h-.622l.502.367-.195.593.51-.36.503.36-.188-.593.503-.367h-.623zm-2.647 0l-.195-.593-.188.593h-.63l.51.367-.195.593.503-.36.51.36-.195-.593.51-.367h-.63zM2.033 3.53l-.188.593h-.63l.51.367-.195.593.503-.368.51.368-.195-.593.51-.367h-.63l-.195-.593zM4.68 1.385l-.195.593h-.622l.502.367-.195.593.51-.368.503.368-.188-.593.503-.367h-.623l-.195-.593zm-2.647 0l-.188.593h-.63l.51.367-.195.593.503-.368.51.368-.195-.593.51-.367h-.63l-.195-.593zM7.32 3.53l-.195.593h-.622l.502.367-.187.593.502-.368.503.368-.188-.593.503-.367h-.623L7.32 3.53zm.195 2.738l-.195-.593-.195.593h-.622l.502.367-.187.593.502-.36.503.36-.188-.593.503-.367h-.623zm2.64 0l-.195-.593-.187.593h-.63l.51.367-.195.593.502-.36.51.36-.195-.593.503-.367h-.623zM9.96 3.53l-.187.593h-.63l.51.367-.195.593.502-.368.51.368-.195-.593.503-.367h-.623L9.96 3.53zM7.32 1.385l-.195.593h-.622l.502.367-.187.593.502-.368.503.368-.188-.593.503-.367h-.623l-.195-.593zm2.64 0l-.187.593h-.63l.51.367-.195.593.502-.368.51.368-.195-.593.503-.367h-.623l-.195-.593z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStates);
export default __webpack_public_path__ + "static/media/UnitedStates.e7a398640cf8a5dacd98d85a9dab4508.svg";
export { ForwardRef as ReactComponent };